import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
    const token = localStorage.getItem('token');

    // Check if the user is authenticated
    if (!token) {
        return <Navigate to="/" />;
    }

    return <Outlet />; // Render child routes if authenticated
};

export default ProtectedRoute;
